// Filtro padrao ao abrir a tela do relatorio (PHOENIX-107, fase 3): logica pura, sem React, para testar com jest.
// A tela abre preenchida com o padrao e nao executa (P2); as formulas de data valem para hoje.
import { isFormula } from './agendamentoRelatorio.utils'

/** { campo: formula } das datas do padrao gravadas com formula, para o resolver-datas. */
export const formulasDoPadrao = (filtros, camposData) => {
  const formulas = {}
  ;(camposData || []).forEach(({ campo }) => {
    if (isFormula(filtros[campo])) {
      formulas[campo] = filtros[campo]
    }
  })
  return formulas
}

/**
 * Os filtros com as formulas das datas trocadas pela data de hoje (yyyy-MM-dd) que o back calculou. Formula que o back
 * nao resolveu sai do filtro: a tela fica com a data que ja tinha. Data fixa fica como esta. So os campos de data: um
 * texto da tela dinamica que comece com '$' nao e formula.
 */
export const comDatasResolvidas = (filtros, camposData, resolvidas) => {
  const resultado = { ...filtros }
  ;(camposData || []).forEach(({ campo }) => {
    if (!isFormula(resultado[campo])) {
      return
    }
    const resolvida = resolvidas && resolvidas[campo]
    if (resolvida && resolvida.data) {
      resultado[campo] = resolvida.data
    } else {
      delete resultado[campo]
    }
  })
  return resultado
}

/** yyyy-MM-dd -> Date local (new Date('yyyy-MM-dd') seria meia-noite UTC, o dia anterior no Brasil); senao null. */
export const dataLocal = (iso) => {
  const partes = /^(\d{4})-(\d{2})-(\d{2})/.exec(typeof iso === 'string' ? iso : '')
  return partes ? new Date(Number(partes[1]), Number(partes[2]) - 1, Number(partes[3])) : null
}

/** O nome do item para o aviso: o rotulo, o valor ou, sem nenhum, o id. */
export const nomeDoItem = (item) => {
  if (item === null || item === undefined) {
    return ''
  }
  if (typeof item !== 'object') {
    return String(item)
  }
  if (item.label !== undefined && item.label !== null && item.label !== '') {
    return String(item.label)
  }
  if (item.value !== undefined && item.value !== null && item.value !== '') {
    return String(item.value)
  }
  return String(item.id)
}

/**
 * Separa os itens de uma lista do filtro gravado pelos que ainda existem nas opcoes ({ id, value }).
 *
 * @param marcados a lista como esta no filtro: { id, value } ou so os ids (forma de pagamento, grupo financeiro)
 * @param chave    o que identifica o item: 'id' na maioria das listas; 'value' nos tipos de sepultura (a tela os
 *                 compara pelo nome, o mesmo tipo tem um id por unidade)
 * @return { validos, descartados }: o valido vem com o id e o nome da opcao (o tipo de outra unidade passa a ter o id
 *         da opcao, a conta renomeada o nome novo), sem repetir id; o descartado, como estava gravado
 */
export const separarPelasOpcoes = (marcados, opcoes, chave = 'id') => {
  const porId = new Map((opcoes || []).map((opcao) => [opcao.id, opcao]))
  const porChave = new Map((opcoes || []).map((opcao) => [opcao[chave], opcao]))
  const validos = []
  const usados = new Set()
  const descartados = []
  ;(Array.isArray(marcados) ? marcados : []).forEach((item) => {
    const soId = item === null || typeof item !== 'object'
    // pelo proprio id primeiro: com varias unidades o mesmo nome de tipo aparece uma vez por unidade, e pelo nome
    // todos virariam o mesmo id
    const opcao = soId ? porId.get(item) : porId.get(item.id) || porChave.get(item[chave])
    if (!opcao) {
      descartados.push(item)
    } else if (!usados.has(opcao.id)) {
      usados.add(opcao.id)
      validos.push(soId ? opcao.id : { id: opcao.id, value: nomeDoItem(opcao) })
    }
  })
  return { validos, descartados }
}

/**
 * Confere as listas do filtro contra as opcoes carregadas agora.
 *
 * @param listas   [{ filtro, chave, opcoes }]: o campo do filtro, a chave de comparacao e as opcoes ({ id, value });
 *                 opcoes null = nao conferir (a lista fica como esta)
 * @return { filtros, descartados }: os filtros so com o que existe e os nomes do que saiu
 */
export const filtrosValidos = (filtros, listas) => {
  const resultado = { ...filtros }
  const descartados = []
  ;(listas || []).forEach(({ filtro, chave, opcoes }) => {
    if (!opcoes || !Array.isArray(resultado[filtro])) {
      return
    }
    const separados = separarPelasOpcoes(resultado[filtro], opcoes, chave)
    resultado[filtro] = separados.validos
    separados.descartados.forEach((item) => descartados.push(nomeDoItem(item)))
  })
  return { filtros: resultado, descartados }
}

/**
 * Aplica na tela o padrao ja preparado, com o contrato que o FiltrosSalvosRelatorio espera de aplicarPadrao: os nomes
 * descartados (aplicou), null (a tela saiu ou o usuario mexeu: vigente() falso) ou o proprio preparado com naoAplicado
 * (nenhuma unidade do padrao esta mais disponivel: aplicar deixaria a tela sem unidade, um relatorio mais amplo que o
 * salvo).
 *
 * @param preparado { record, descartados, naoAplicado }
 * @param aplicar   (preparado) => void: os setField da tela
 */
export const aplicarPreparado = (preparado, vigente, aplicar) => {
  if (!vigente()) {
    return null
  }
  if (preparado.naoAplicado) {
    return preparado
  }
  aplicar(preparado)
  return preparado.descartados
}

/**
 * O padrao nao pode ser aplicado: tinha unidades e nenhuma esta mais disponivel para o usuario.
 *
 * @param gravadas as unidades gravadas no padrao
 * @param validas  as que sobraram depois de conferidas
 */
export const semUnidadeDisponivel = (gravadas, validas) =>
  Array.isArray(gravadas) && gravadas.length > 0 && Array.isArray(validas) && validas.length === 0
